<template>
  <div class="swagger-dialog">
    <v-dialog v-model="dialog" fullscreen hide-overlay transition="dialog-bottom-transition">
      <v-card tile>
        <v-toolbar dark color="primary">
          <v-toolbar-title>{{url ? url + '/ui' : 'No Url'}}</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon dark @click="$emit('close')">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-toolbar>
        <iframe
          v-if="url"
          class="block"
          :src="`${url}/ui`"
          frameborder="1"
          width="100%"
          style="position:fixed; height: calc(100% - 60px)"
        ></iframe>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default {
  props: {
    dialog: { type: Boolean, required: true },
    url: { type: String }
  }
};
</script>

<style>
</style>